import objectFitImages from 'object-fit-images';

// import Highway from '@dogstudio/highway';

import Home from './renderers/home';
import Shop from './renderers/shop';
import Product from './renderers/product';
import Gang from './renderers/gang';
import About from './renderers/about';
import Cart from './renderers/cart';
import BigOrder from './renderers/bigorder';
import ClickCollect from './renderers/clickcollect';
import Nav from './components/nav';

// import Collect from './components/collect';
// import Sound from './components/sound';

// import Fade from './animations/fade';

objectFitImages();

document.addEventListener('DOMContentLoaded', () => {
	// DOM loaded

    new Nav();
    // new Collect();

    if(document.body.classList.contains('home')){
    	new Home();
	}

	if(document.body.classList.contains('page-template-shop')){
    	new Shop();
	}

	if(document.body.classList.contains('single-product')){
    	new Product();
	}

	if(document.body.classList.contains('page-template-gang')){
    	new Gang();
	}

	if(document.body.classList.contains('page-template-about')){
    	new About();
	}

	if(document.body.classList.contains('page-template-cart')){
    	new Cart();
	}

  if(document.body.classList.contains('page-template-big-order')){
      new BigOrder();
  }

  if(document.body.classList.contains('page-template-clickcollect')){
      new ClickCollect();
  }

  tarteaucitron.init({
    "privacyUrl": "",
    "hashtag": "#tarteaucitron",
    "cookieName": "tarteaucitron",
    "orientation": "popup",
    "groupServices": false,
    "showAlertSmall": false,
    "cookieslist": false,
    "closePopup": false,
    "showIcon": true,
    "iconPosition": "BottomLeft",
    "adblocker": false,
    "DenyAllCta" : true,
    "AcceptAllCta" : true,
    "highPrivacy": true,
    "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */
    "removeCredit": false, /* Remove credit link */
    "moreInfoLink": true,
    "useExternalCss": false,
    "useExternalJs": false,
    "readmoreLink": "",
    "mandatory": true,
  });

  tarteaucitron.user.gtagUa = 'UA-130094529-5';
  (tarteaucitron.job = tarteaucitron.job || []).push('gtag');
});